import { ReactComponent as BooksImg } from "@/asset/img/books.svg";

export default BooksImg;
